import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import MenuItem from '../MenuItem'
import Text from '#components/a/Text'
import {routeHelper} from '#config/routeKeys'
import {useAzubisWithAusbildungsplanModul} from '#hooks/store/useAzubisWithAusbildungsplanModul'
import Pagination from '#components/m/Pagination'
import Loading from '#components/a/Loading'
import {useSelector} from 'react-redux'
import {usePermissions} from '#hooks/usePermissions'

function renderAzubiList(azubiList, hasSubmittedChapters, noAzubiText, loading) {
  if (azubiList?.length === 0 && !loading) {
    return (
      <div className="menu__text">
        <Text text={noAzubiText} />
      </div>
    )
  }
  if (loading) {
    return <Loading />
  }
  return azubiList?.map(azubi => (
    <li key={azubi.id} className="menu__item">
      <MenuItem
        url={routeHelper.ausbildungsplanForUser(azubi.id)}
        text={`${azubi.lastname}, ${azubi.firstname}`}
        hasSubmittedChapter={hasSubmittedChapters(azubi.id)}
      />
    </li>
  ))
}

function AzubiList({azubis, hasSubmittedChapters, noAzubiText, loading}) {
  const [visibleAzubis, setVisibleAzubis] = useState([])
  const scroll = (skip, take) => {
    setVisibleAzubis(azubis.slice(skip, skip + take))
  }
  return (
    <div data-testid="primary-azubilist">
      <h3 className="menu__item--headline">{i18n.t('ausbildungsplan_submenu_azubis')}</h3>
      <Pagination data={azubis} scrollCallback={scroll} />
      <ul className="menu__level--azubis">
        {renderAzubiList(visibleAzubis, hasSubmittedChapters, noAzubiText, loading)}
      </ul>
    </div>
  )
}

AzubiList.propTypes = {
  hasSubmittedChapters: PropTypes.func.isRequired,
  noAzubiText: PropTypes.string,
  azubis: PropTypes.array,
  loading: PropTypes.bool,
}

function AusbildungsplanAzubiListMenu({hasSubmittedChapters}) {
  const permissions = usePermissions()
  const canFilterByMyAbteilungen = permissions.meineAzubis.canFilterAzubisByMyAbteilungen
  const filter = useSelector(state => state.filter)
  const selectedAzubiIdsFromGlobalFilter = filter ? filter.matchingAzubiIds : []
  const {allAzubis, loading} = useAzubisWithAusbildungsplanModul()

  const filteredAzubis = allAzubis.filter(azubi => selectedAzubiIdsFromGlobalFilter.includes(azubi.id))
  const noAzubisText = canFilterByMyAbteilungen
    ? i18n.t('no_azubi_with_this_module_with_fachabteilung_filter_visible')
    : i18n.t('no_azubi_with_this_module')

  return (
    <div>
      <AzubiList
        azubis={filteredAzubis}
        hasSubmittedChapters={hasSubmittedChapters}
        noAzubiText={noAzubisText}
        loading={loading}
      />
    </div>
  )
}

AusbildungsplanAzubiListMenu.propTypes = {
  hasSubmittedChapters: PropTypes.func.isRequired,
}

export default AusbildungsplanAzubiListMenu
